/* cookie */
import HmacSHA256 from 'crypto-js/hmac-sha256';

export function hmacSha256(doc,key){
  return HmacSHA256(doc,key).toString();
}
export function setCookie(name, value, expires) {
  var exp = new Date();
  exp.setTime(exp.getTime() + expires * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
}
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
export function clearCookie() {
  var date = new Date();
  date.setTime(date.getTime() - 10000);
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;domain=;expires='+date.toGMTString()+";path=/";
    }
  }
}
/* cookie */
